import React, { useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'
import i18n from 'i18n'
import { getSavedLanguage, readLanguage, writeLanguage } from './preferences'
import { updateProfileLanguage } from 'service/AccountSettingsService'

export default function LanguageProvider({ children }) {
  const user = useSelector(state => state.user)
  const current = useRef(null)
  useEffect(() => {
    const id = user.userId
    if (current.current === id) return
    current.current = id
    let loginChoice
    try { loginChoice = sessionStorage.getItem('erp-language-login-choice'); if (id) sessionStorage.removeItem('erp-language-login-choice') } catch { /* Storage may be unavailable. */ }
    const next = id ? loginChoice || user.interface_language || getSavedLanguage(id) || readLanguage() : readLanguage()
    i18n.changeLanguage(next)
    if (id) writeLanguage(next, id)
    if (id && loginChoice) changeInterfaceLanguage(next, id)
  }, [user.userId, user.interface_language])
  useEffect(() => {
    const sync = event => {
      if (event.key === 'erp-language' || event.key === `erp-language:user:${user.userId}`) i18n.changeLanguage(readLanguage(user.userId))
    }
    window.addEventListener('storage', sync)
    return () => window.removeEventListener('storage', sync)
  }, [user.userId])
  return children
}
let saveQueue = Promise.resolve()
export async function changeInterfaceLanguage(language, userId) {
  if (!writeLanguage(language, userId)) return
  await i18n.changeLanguage(language)
  if (!userId) { try { sessionStorage.setItem('erp-language-login-choice', language) } catch { /* Storage may be unavailable. */ } return }
  try {
    saveQueue = saveQueue.catch(() => {}).then(() => {
      const active = JSON.parse(localStorage.getItem('user') || '{}')
      if (String(active.user ?? active.user_id) === String(userId)) return updateProfileLanguage(language)
    })
    await saveQueue
    if (readLanguage(userId) !== language) return
    const profile = JSON.parse(localStorage.getItem('user') || '{}')
    if (String(profile.user ?? profile.user_id) === String(userId)) {
      profile.interface_language = language
      localStorage.setItem('user', JSON.stringify(profile))
    }
  } catch { /* A local preference remains available offline. */ }
}
